import { ModalTypes, ModalActionTypes } from "./index";

export function setModalIsOpened(open: boolean, name: string | null, ownerId?: string): ModalActionTypes {
	return {
		type: ModalTypes.SET_MODAL_IS_OPENED,
		payload: { open, name, ownerId },
	};
}

export function releaseModal(ownerId: string): ModalActionTypes {
	return {
		type: ModalTypes.RELEASE_MODAL,
		payload: { ownerId },
	};
}
